import { render } from "./LiveIcon.vue?vue&type=template&id=eb95a64a&scoped=true"
import script from "./LiveIcon.vue?vue&type=script&lang=js"
export * from "./LiveIcon.vue?vue&type=script&lang=js"

import "./LiveIcon.vue?vue&type=style&index=0&id=eb95a64a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb95a64a"]])

export default __exports__